/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ReactNode } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { Box, Inline, Text } from '@atlaskit/primitives/compiled';

const DETAIL_ROW_HEIGHT = '2.5rem';

const styles = cssMap({
	detailRow: {
		height: DETAIL_ROW_HEIGHT,
		minHeight: DETAIL_ROW_HEIGHT,
	},
	detailLabel: {
		width: '5.125rem',
		flexShrink: 0,
	},
	detailValue: {
		minWidth: '0',
		flexGrow: 1,
	},
});

export const DetailRow = ({
	label,
	children,
}: {
	label: string;
	children: ReactNode;
}): JSX.Element => (
	<Inline space="space.100" alignBlock="center" xcss={styles.detailRow}>
		<Box xcss={styles.detailLabel}>
			<Text color="color.text.subtle">{label}</Text>
		</Box>
		<Box xcss={styles.detailValue}>{children}</Box>
	</Inline>
);
